<div class="text-center text-sm font-medium" [title]="title() ?? ''">{{ count() | number }}</div>
<div class="h-[10px] rounded-[2px] self-stretch" [ngClass]="bgColorClass()" [title]="title() ?? ''"></div>
